import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Compass = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Compass' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M10,10 L15,9 L14,14 L9,15 L10,10 Z M12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 Z' />
  </StyledIcon>
);
